import Vue from 'vue'
import Moment from 'moment'
import VueFormWizard from 'vue-form-wizard'
import Swal from 'sweetalert2'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import ElementUI from 'element-ui'
import dateUtil from 'element-ui/lib/utils/date'
import money from 'v-money'
import VueNumeric from 'vue-numeric'
import PSwitch from '@/components/UIComponents/Switch.vue'
import Formatacao from '@/services/Formatacao'
import API from '@/services/API'
import Armazenamento from '@/services/Armazenamento'
import Assinatura from '@/services/Assinatura'
import Compartilhamento from '@/services/Compartilhamento'
import ResultadosPastoCompleto from '@/assets/resultados-pasto-completo.json'

Vue.use(ElementUI);
Vue.use(money);
Vue.use(VueNumeric);
Vue.use(VueFormWizard);
Vue.use(VueFormWizard)

const controller = {
  name: 'PastoCompletoCtrl',
  components: {
    PSwitch,
    money
  },
  props: [ 'novo' ],
  data () {
    return {
      compartilhado: {
        assinatura: Compartilhamento.assinatura.dados
      },
      loading: false,
      descricoes: null,
      resultDone: false,
      racasOpcoes: null,
      estados: null,
      todasCidades: '',
      todosEstados: [],
      cidades: '',
      money: {
        decimal: '.',
        thousands: ',',
        precision: 2,
        masked: false
      },
      precision2: {
        decimal: ',',
        thousands: '.',
        precision: 2,
        masked: false
      },
      precision3: {
        decimal: ',',
        thousands: '.',
        precision: 3,
        masked: false
      },
      formIndex: 3,
      orcamento: '',
      totalDeAnimaisDoLote: '',
      racaAnimais: '',
      sexoAnimais: '',
      padraoRacial: '',
      pesoMedioEntradaKgCabBaseOrigem: '',
      quantidadeDiariasArracoamento: '',
      GMDKgD: '',
      idadeEntradaMeses: '0',
      mortalidade: '',
      consumoDeMateriaSecaDoPVOpcional: '',
      materiaSecaDaDietaOpcional: '',
      estado: '',
      cidade: '',
      frigorifico: '',
      propriedade: '',
      quebraDePesoOrigemBalancaoDestino: '',
      quebraDePesoOrigemBalancinhaDestino: '',
      rendimentoCarcacaEntrada: '',
      rendimentoCaracaAbate: '',
      pesoDeEntradaParaBoitelViaArrobaProduzidaOpcional: '',
      rendimentoDeEntradaBoitelViaArrobaProduzidaOpcional: '',
      pesoDeEntradaEspecificoParaBoitelViaParceriaOpcional: '',
      rendimentoDeEntradaEspecificoBoitelViaParceriaOpcional: '',
      valorGadoCabecaCIF: '',
      precoReferenciaBoiGordo: '',
      taxaRemuneracaoCapital: '',
      dataPagamentoGado: '',
      dataD1: '',
      dataFinal: '',
      despesasComercializacao: '',
      despesasCabecasMes: '',
      custoFixoTotal: '',
      custoVariavelExcetoNutricao: '',
      dataD1Arracoamento: '',
      diasEntreEmbarqueAbate: '',
      diasEntreAbateRecebimento: '',
      diasExtrasRecebimento: '',
      deducoesAplicadasROB: '',
      uaMediaCiclo: '',
      depreciacao: '',
      amortizacao: '',
      naoOperacional: '',
      impostoRenda: '',
      precoVenda: '',
      diferencialBase: '',
      descontoAplicadoVendaVista: '',
      premioEU: '',
      premioHilton: '',
      premioAngus: '',
      premioAcabamento: '',
      outrosPremios: '',
      precoDaArrobaProduzida: '',
      custoOperacionalCabDia: '',
      custoDeNutricaoDiarioMedioCABdia: '',
      custoDeProtocoloSanitarioSisbovCAB: '',
      custoDeMedicamentosOutrosCAB: '',
      despesaDeGTAFunruralGadoDeEngordaTerceirizadaCAB: '',
      despesaDeFreteCAB: '',
      despesaComissaoCompraCab: '',
      despesaDeGTADeAbateCAB: '',
      despesaDeAbateAssessoriaOutrasDespesasCAB: '',
      despesaDeICMSCAB: '',
      nome: '',
      simNaoOpcoes: [{
        id: 'Sim',
        label: 'Sim'
      }, {
        id: 'Não',
        label: 'Não'
      }],
      sexoAnimaisOpcoes: [{
        id: 'Macho Castrado',
        label: 'Macho Castrado'
      }, {
        id: 'Macho Inteiro',
        label: 'Macho Inteiro'
      }, {
        id: 'Fêmea',
        label: 'Fêmea'
      }],
      modalidadeDaVendaOpcoes: [{
        id: 'Mercado Spot ou balcão',
        label: 'Mercado Spot ou balcão'
      }, {
        id: 'Mercado de opções',
        label: 'Mercado de opções'
      }, {
        id: 'Mercado a termo (fixo)',
        label: 'Mercado a termo (fixo)'
      }, {
        id: 'Mercado futuro',
        label: 'Mercado futuro'
      }, {
        id: 'Mercado a termo (a fixar)',
        label: 'Mercado a termo (a fixar)'
      }, {
        id: 'Mercado a termo (preço mínimo)',
        label: 'Mercado a termo (preço mínimo)'
      }],
      modalidadeDaVendaEscolhida: '',
      modalidadeDeSistemaDeProducaoOpcoes: [{
        id: 'Confinamento próprio',
        label: 'Confinamento próprio'
      }, {
        id: 'Boitel - kg de alimento consumido',
        label: 'Boitel - kg de alimento consumido'
      }, {
        id: 'Parceria',
        label: 'Parceria'
      }, {
        id: 'Boitel - diária',
        label: 'Boitel - diária'
      }, {
        id: 'Semiconfinamento ou Confinamento em pasto',
        label: 'Semiconfinamento ou Confinamento em pasto'
      }, {
        id: 'Boitel - @ produzida',
        label: 'Boitel - @ produzida'
      }],
      modalidadeDeSistemaDeProducaoEscolhida: '',
      estagioNegocioOpcoes: [{
        id: 'treinamento',
        label: 'Treinamento'
      }, {
        id: 'orcamento',
        label: 'Orçamento'
      }, {
        id: 'inicioOperacao',
        label: 'Início de Operação'
      }, {
        id: 'encerramentoOperacao',
        label: 'Encerramento de Operação'
      }],
      estagioNegocio: '',
      switches: {
        defaultOn: true,
        plainOn: true,
        withIconsOn: true
      },
      inicioDeOperacao: '',
      encerramentoDeOperacao: '',
      activePanels: ['1', '2', '3', '4'],
      resultados: ResultadosPastoCompleto.resultados,
      fasesDoCiclo: [{
        indexId: 'abc-123',
        dataInicial: '',
        dataFinal: '',
        duracao: 0,
        gmdKgd: 0,
        pesoInicial: 0,
        pesoFinal: 0,
        pesoMedio: 0,
        suplemento: '',
        consumoPV: 0,
        consumoKG: 0,
        preco: 0,
        custo: 0
      }],
      consolidado: {
        dataFinal: '',
        duracao: 0,
        gmdKgd: 0,
        pesoInicial: 0,
        pesoFinal: 0,
        pesoMedio: 0,
        suplemento: '',
        consumoPV: 0,
        consumoKG: 0,
        preco: 0,
        custo: 0
      }
    }
  },
  methods: {
    isMobile () {
      var check = false;
      (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    },
    clear (event) {
      event.target.value = ''
    },
    guid () {
      function s4 () {
        return Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1);
      }
      return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    },
    validacaoEtapa1 () {
      if (this.nome === '' ||
      this.modalidadeDaVendaEscolhida === '' || this.modalidadeDaVendaEscolhida === null || this.modalidadeDaVendaEscolhida.length === 0 ||
      this.estagioNegocio === '' || this.estagioNegocio === null) {
        Swal('Preencha os campos', 'Por favor, preencha todos os campos marcados como obrigatórios "*" ', 'warning');
        return false
      }
      return true
    },
    validacaoEtapa2 () {
      if (this.totalDeAnimaisDoLote === '' || parseFloat(Formatacao.converterStringParaNumero(this.totalDeAnimaisDoLote)) <= 0 ||
      this.sexoAnimais === '' || this.sexoAnimais === null ||
      parseFloat(Formatacao.converterStringParaNumero(this.idadeEntradaMeses)) <= 0 || this.idadeEntradaMeses === null ||
      parseFloat(Formatacao.converterStringParaNumero(this.rendimentoCarcacaEntrada)) <= 0 || this.rendimentoCarcacaEntrada === null ||
      parseFloat(Formatacao.converterStringParaNumero(this.rendimentoCaracaAbate)) <= 0 || this.rendimentoCaracaAbate === null ||
      this.padraoRacial === '' || this.uaMediaCiclo === '' || this.estado === '') {
        Swal('Preencha os campos', 'Por favor, preencha todos os campos marcados como obrigatórios "*" ', 'warning');
        return false
      }
      return true
    },
    removerFase (item, index) {
      this.fasesDoCiclo = this.fasesDoCiclo.filter(function (el) {
        return el.indexId !== item.indexId;
      });
    },
    addFase (item) {
      if (this.fasesDoCiclo.length > 7) {
        Swal('Aviso', 'Máximo de 8 fases permitido', 'warning');
        return
      }
      if (parseFloat(item.duracao) <= 0) {
        Swal('Aviso', 'Duração deve ser maior que 0 dias', 'warning');
        return
      }
      if (item.dataInicial === '' || item.dataInicial === null ||
      item.dataFinal === '' || item.dataFinal === null ||
      item.duracao === '' || item.duracao === null ||
      item.gmdKgd === '' || item.gmdKgd === null ||
      parseFloat(item.pesoInicial) <= 0 || item.pesoInicial === null ||
      parseFloat(item.pesoFinal) <= 0 || item.pesoFinal === null ||
      parseFloat(item.pesoMedio) <= 0 || item.pesoMedio === null ||
      item.suplemento === '' || item.suplemento === null ||
      parseFloat(item.consumoPV) === '' || item.consumoPV === null ||
      parseFloat(item.consumoKG) === '' || item.consumoKG === null ||
      parseFloat(Formatacao.converterStringParaNumero(item.preco)) <= 0 || item.preco === null ||
      parseFloat(item.custo) <= 0 || item.custo === null) {
        Swal('Aviso', 'Preencha todos os dados da fase atual.', 'warning');
        return
      }
      let proximaData = Moment(item.dataFinal, 'DD/MM/YYYY').add(1, 'days');
      this.fasesDoCiclo.push(
        {
          indexId: this.guid(),
          dataInicial: proximaData.toDate(),
          dataFinal: proximaData.add(1, 'day').toDate(),
          duracao: 1,
          gmdKgd: 0,
          pesoInicial: item.pesoFinal,
          pesoFinal: item.pesoFinal,
          pesoMedio: item.pesoFinal,
          suplemento: '',
          consumoPV: 0,
          consumoKG: 0,
          preco: 0,
          custo: 0
        })
      console.log(parseFloat(item.pesoFinal).toFixed(3))
    },
    calculaValores (item_, index) {
      this.fasesDoCiclo.forEach((el, i) => {
        if (i >= index) {
          if (i > index) {
            el.pesoInicial = this.fasesDoCiclo[i - 1].pesoFinal.replace('.', ',');
            el.dataInicial = Moment(this.fasesDoCiclo[i - 1].dataFinal).add(1, 'day').toDate();
          }
          let item = el;
          let dataInicial = '';
          if (item.dataInicial !== '' && item.dataInicial !== null) {
            dataInicial = Moment(item.dataInicial, 'DD/MM/YYYY');
            if (item.dataFinal == '' || item.dataFinal == null) {
              dataFinal = Moment(item.dataInicial, 'DD/MM/YYYY');
              item.dataFinal = dataFinal.add(1, 'days').toDate();
              // item.dataFinal = item.dataInicial;
            }
          }
          let dataFinal = '';
          if (item.dataFinal !== '' && item.dataFinal !== null) {
            dataFinal = Moment(item.dataFinal, 'DD/MM/YYYY');
          }
          if (dataInicial !== '' && dataFinal !== '') {
            let diferencaEmDias = parseFloat(dataFinal.diff(dataInicial, 'days')) + 1;
            if (diferencaEmDias >= 0) {
              item.duracao = String(diferencaEmDias)
            } else {
              item.dataFinal = '';
            }
          }
          if (!this.resultDone) {
            item.suplemento = String(item.suplemento);

            // Calculo do Peso Final
            let isIE = !!document.documentMode; // Verifica se o Browser é Internet Explorer
            if (isIE) {
              var pesoInicial;
              if (item.indexId != 'abc-123') {
                pesoInicial = item.pesoInicial;
              } else {
                pesoInicial = Formatacao.converterStringParaNumero(item.pesoInicial);
              }
            } else {
              var pesoInicial = Formatacao.converterStringParaNumero(item.pesoInicial);
            }
            let duracao = Formatacao.converterStringParaNumero(item.duracao);
            let gmdKgd = Formatacao.converterStringParaNumero(item.gmdKgd);
            item.duracao = String(duracao);
            let pesoFinal = parseFloat(pesoInicial) + (parseFloat(duracao) * parseFloat(gmdKgd))
            if (parseFloat(duracao) > 0) {
              parseFloat(item.pesoFinal).toFixed(3)
              item.pesoFinal = String(pesoFinal.toFixed(3))
            }

            // Calculo do Peso Médio
            let pesoMedio = (parseFloat(pesoInicial) + pesoFinal) / 2;
            item.pesoMedio = String(pesoMedio.toFixed(3));

            // Calculo Consumo KG
            let consumoKG = (pesoMedio * parseFloat(Formatacao.converterStringParaNumero(item.consumoPV))) / 100
            item.consumoKG = String(consumoKG.toFixed(3));

            // Calculo Custo Total preco*consumokg*duracao
            let preco = parseFloat(Formatacao.converterStringParaNumero(item.preco));
            let custo = preco * consumoKG * duracao;
            item.custo = String(custo.toFixed(2));

            // Calcula Consolidado
            let primeiraFase = this.fasesDoCiclo[0];
            let ultimaFase = this.fasesDoCiclo[this.fasesDoCiclo.length - 1];
            if (ultimaFase.dataFinal !== '') {
              this.consolidado.dataFinal = dateUtil.format(ultimaFase.dataFinal, 'dd/MM/yyyy');
            }
            let duracaoFinal = 0;
            let custoFinal = 0;
            let precoMedio = 0;
            let gmdFinal = 0;
            let consumoFinal = 0;
            let consumoFinalKG = 0;
            for (let i = 0; i < this.fasesDoCiclo.length; i++) {
              duracaoFinal = duracaoFinal + parseFloat(this.fasesDoCiclo[i].duracao);
              custoFinal = custoFinal + parseFloat(this.fasesDoCiclo[i].custo);
              precoMedio = precoMedio + parseFloat(this.fasesDoCiclo[i].preco);
              gmdFinal = gmdFinal + (parseFloat(Formatacao.converterStringParaNumero(this.fasesDoCiclo[i].duracao)) * parseFloat(Formatacao.converterStringParaNumero(this.fasesDoCiclo[i].gmdKgd)))
              consumoFinal = consumoFinal + (parseFloat(Formatacao.converterStringParaNumero(this.fasesDoCiclo[i].duracao)) * parseFloat(Formatacao.converterStringParaNumero(this.fasesDoCiclo[i].consumoPV)))
              consumoFinalKG = consumoFinalKG + (parseFloat(Formatacao.converterStringParaNumero(this.fasesDoCiclo[i].duracao)) * parseFloat(Formatacao.converterStringParaNumero(this.fasesDoCiclo[i].consumoKG)))
            }
            gmdFinal = gmdFinal / duracaoFinal;
            consumoFinal = consumoFinal / duracaoFinal;
            consumoFinalKG = consumoFinalKG / duracaoFinal;
            precoMedio = precoMedio / this.fasesDoCiclo.length;
            this.consolidado.duracao = String(duracaoFinal);
            this.consolidado.gmdKgd = String(parseFloat(gmdFinal).toFixed(3));
            this.consolidado.pesoInicial = String(parseFloat(Formatacao.converterStringParaNumero(primeiraFase.pesoInicial)).toFixed(3));
            this.consolidado.pesoFinal = String(parseFloat(ultimaFase.pesoFinal).toFixed(3));

            this.consolidado.pesoMedio = ((parseFloat(this.consolidado.pesoInicial) + parseFloat(this.consolidado.pesoFinal)) / 2).toFixed(3);
            this.consolidado.suplemento = '-';
            this.consolidado.consumoPV = String(consumoFinal.toFixed(3));
            this.consolidado.consumoKG = String((consumoFinalKG / 1000).toFixed(3));
            this.consolidado.preco = String(((custoFinal / duracaoFinal) / (consumoFinalKG / 1000)).toFixed(2));
            this.consolidado.custo = String(custoFinal.toFixed(2));
          }
        }
      });
    },
    redResults () {
      let t = document.getElementById('receita');
      let trs = t.getElementsByTagName('tr');
      let bs = null;

      for (let i = 0; i < trs.length; i++) {
        bs = trs[i].getElementsByTagName('b');
        for (let n = 0; n < bs.length; n++) {
          let content = Formatacao.replaceAll(bs[n].textContent, '.', '');
          content = Formatacao.replaceAll(content, ',', '.');
          let contentNum = parseFloat(content);
          console.log(contentNum);
          if (contentNum < 0) {
            bs[n].classList.add('redVal');
          }
        }
      }
    },
    formatPrice (value) {
      let val = (value / 1).toFixed(2)
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    onFilterCidade (query) {
      this.cidades = this.todasCidades.filter(item => {
        return Formatacao.removerAcentos(String(item.nome).toLowerCase()).includes(query.toLowerCase());
      });
    },
    onFilterEstado (query) {
      this.estados = this.todosEstados.filter(item => {
        return Formatacao.removerAcentos(String(item.nome).toLowerCase()).includes(query.toLowerCase());
      });
    },
    onEstadoChanged (sigla) {
      const estado = this.estados.filter(estado => estado.sigla === sigla);
      if (estado.length === 1) {
        this.cidade = '';
        this.todasCidades = estado[0]['cidades'];
        this.cidades = this.todasCidades;
      }
    },
    showMessage (message) {
      if (message !== null && message !== '') {
        Swal({
          title: message,
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-success btn-fill'
        })
      }
    },
    showMissingAnswerMessage () {
      Swal({
        title: 'Por favor, preencha todos os campos obrigatórios marcados com *.',
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-success btn-fill'
      })
    },
    showMissingAnswerMessageWithParams (params) {
      Swal({
        title: 'Por favor, preencha os campos: ' + params + '.',
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-success btn-fill'
      })
    },
    novaSimulacaoBaseada () {
      let card = document.getElementsByClassName('card');
      for (let i = 0; i < card[0].getElementsByTagName('input').length; i++) {
        card[0].getElementsByTagName('input')[i].disabled = false;
      }
      this.resultDone = false;
      this.$refs.wizard.changeTab(1, 0)
    },
    reload () {
      this.$router.replace({
        name: 'pasto-avancado-criar'
      }, () => window && window.location && window.location.reload());
    },
    getInitialValues () {
      const animais = API.listar.animais()
      const descricoes = API.descricoes.buscar(4)
      const estados = API.listar.estados()
      return Promise.all([animais, descricoes, estados])
    },
    getSimulation () {
      let that = this;
      let id = this.$router.history.current.params.id
      if (id) {
        API.simulacao.buscar(id)
          .then(response => {
            if (response.status === 200) {
              that.resultados = response.data.simulacao.simulacao_saida.dados.resultados;
              let entrada = response.data.simulacao.simulacao_entrada.dados;
              this.handleInput(entrada)
              this.$refs.wizard.changeTab(0, 3)
            } else {
              console.error(' #getSimulation (then -> else) Algo deu errado, recarregue a página')
            }
          })
          .catch(e => {
            console.error(' #getSimulation (catch) Algo deu errado, recarregue a página')
            console.error(e)
            this.$router.push({
              name: 'pasto-avancado-criar'
            }, window && window.location && window.location.reload());
          })
      }
    },
    handleInput (entrada) {
      this.resultDone = true;
      let card = document.getElementsByClassName('card');
      for (let i = 0; i < card[0].getElementsByTagName('input').length; i++) {
        card[0].getElementsByTagName('input')[i].disabled = true;
      }
      this.consolidado = entrada.informacoes.ciclo.consolidado;
      let fases = entrada.informacoes.ciclo;
      delete fases.consolidado;
      fases = Object.values(fases);
      this.fasesDoCiclo = fases;
      for (let x = 0; x < this.fasesDoCiclo.length; x++) {
        this.fasesDoCiclo[x].indexId = this.guid();
        this.fasesDoCiclo[x].dataFinal = Moment(this.fasesDoCiclo[x].dataFinal, 'DD/MM/YYYY').toDate();
        this.fasesDoCiclo[x].dataInicial = Moment(this.fasesDoCiclo[x].dataInicial, 'DD/MM/YYYY').toDate();
      }
      this.estagioNegocio = entrada.sistemaProducao[0].label;
      this.modalidadeDaVendaEscolhida = entrada.modalidadeVenda;
      this.sexoAnimais = entrada.informacoes.produtiva.sexoAnimais.id;
      this.racaAnimais = entrada.informacoes.produtiva.racaAnimais;
      this.idadeEntradaMeses = entrada.informacoes.produtiva.idadeEntradaMeses;
      this.mortalidade = entrada.informacoes.produtiva.mortalidade;
      this.propriedade = entrada.informacoes.produtiva.propriedade;
      this.precoReferenciaBoiGordo = entrada.informacoes.financeira.precoReferenciaBoiGordo;
      this.taxaRemuneracaoCapital = entrada.informacoes.financeira.taxaRemuneracaoCapital;
      this.dataPagamentoGado = Moment(entrada.informacoes.financeira.dataPagamentoGado, 'DD/MM/YYYY').toDate();
      this.despesasComercializacao = entrada.informacoes.financeira.despesasComercializacao;
      this.despesasCabecasMes = entrada.informacoes.financeira.despesasCabecasMes;
      this.custoFixoTotal = entrada.informacoes.financeira.custoFixoTotal;
      this.custoVariavelExcetoNutricao = entrada.informacoes.financeira.custoVariavelExcetoNutricao;
      this.diasEntreEmbarqueAbate = entrada.informacoes.financeira.diasEntreEmbarqueAbate;
      this.diasEntreAbateRecebimento = entrada.informacoes.financeira.diasEntreAbateRecebimento;
      this.diasExtrasRecebimento = entrada.informacoes.financeira.diasExtrasRecebimento;
      this.deducoesAplicadasROB = entrada.informacoes.financeira.deducoesAplicadasROB;
      this.depreciacao = entrada.informacoes.financeira.depreciacao;
      this.amortizacao = entrada.informacoes.financeira.amortizacao;
      this.naoOperacional = entrada.informacoes.financeira.naoOperacional;
      this.impostoRenda = entrada.informacoes.financeira.impostoRenda;
      this.precoVenda = entrada.informacoes.financeira.precoVenda;
      this.diferencialBase = entrada.informacoes.financeira.diferencialBase;
      this.descontoAplicadoVendaVista = entrada.informacoes.financeira.descontoAplicadoVendaVista;
      this.premioEU = entrada.informacoes.financeira.premioEU;
      this.premioHilton = entrada.informacoes.financeira.premioHilton;
      this.premioAngus = entrada.informacoes.financeira.premioAngus;
      this.premioAcabamento = entrada.informacoes.financeira.premioAcabamento;
      this.outrosPremios = entrada.informacoes.financeira.outrosPremios;
      this.despesasComercializacao = entrada.informacoes.financeira.despesasComercializacao;
      this.uaMediaCiclo = entrada.informacoes.produtiva.uaMediaCiclo;
      this.frigorifico = entrada.informacoes.produtiva.frigorifico;
      this.estado = entrada.informacoes.produtiva.estado;
      this.cidade = entrada.informacoes.produtiva.cidade;
      this.totalDeAnimaisDoLote = entrada.informacoes.produtiva.totalAnimaisLote;
      this.rendimentoCarcacaEntrada = entrada.informacoes.produtiva.rendimentoCarcacaEntrada;
      this.rendimentoCaracaAbate = entrada.informacoes.produtiva.rendimentoCaracaAbate;
      this.nome = entrada.nome;
      this.padraoRacial = entrada.informacoes.produtiva.padraoRacial[0].value;
      this.valorGadoCabecaCIF = entrada.informacoes.financeira.valorGadoCabecaCIF;
    },
    formatarDadosAntesDeCalcular () {
      let that = this;
      let novoCiclo = this.fasesDoCiclo;
      let ciclo = {};
      for (let i = 0; i < novoCiclo.length; i++) {
        let key = 'fase_' + String(i + 1);
        ciclo[key] = {
          dataInicial: dateUtil.format(novoCiclo[i].dataInicial, 'dd/MM/yyyy'),
          dataFinal: dateUtil.format(novoCiclo[i].dataFinal, 'dd/MM/yyyy'),
          gmdKgd: Formatacao.replaceAll(String(novoCiclo[i].gmdKgd), ',', '.'),
          pesoInicial: Formatacao.replaceAll(String(novoCiclo[i].pesoInicial), ',', '.'),
          pesoFinal: Formatacao.replaceAll(String(novoCiclo[i].pesoFinal), ',', '.'),
          pesoMedio: Formatacao.replaceAll(String(novoCiclo[i].pesoMedio), ',', '.'),
          consumoPV: Formatacao.replaceAll(String(novoCiclo[i].consumoPV), ',', '.'),
          consumoKG: Formatacao.replaceAll(String(novoCiclo[i].consumoKG), ',', '.'),
          preco: Formatacao.replaceAll(String(novoCiclo[i].preco), ',', '.'),
          custo: Formatacao.replaceAll(String(novoCiclo[i].custo), ',', '.'),
          suplemento: novoCiclo[i].suplemento
        }
      }

      ciclo['consolidado'] = this.consolidado;

      let padraoRacial = this.racasOpcoes.padrao.filter(function (el) {
        return el.value === that.padraoRacial
      });
      let racaAnimais = that.racaAnimais;
      let data = {
        nome: this.nome,
        modalidadeVenda: that.modalidadeDaVendaEscolhida,
        sistemaProducao: that.estagioNegocioOpcoes.filter(function (el) {
          return String(el.label).toLowerCase() === String(that.estagioNegocio).toLowerCase()
        }),
        informacoes: {
          produtiva: {
            totalAnimaisLote: String(this.totalDeAnimaisDoLote),
            racaAnimais: racaAnimais,
            sexoAnimais: that.sexoAnimaisOpcoes.filter(function (el) {
              return el.id === that.sexoAnimais
            })[0],
            idadeEntradaMeses: String(that.idadeEntradaMeses),
            padraoRacial: padraoRacial,
            cidade: this.cidade,
            estado: this.estado,
            frigorifico: String(that.frigorifico),
            propriedade: String(that.propriedade),
            rendimentoCarcacaEntrada: String(Formatacao.converterStringParaNumero(that.rendimentoCarcacaEntrada)),
            rendimentoCaracaAbate: String(Formatacao.converterStringParaNumero(that.rendimentoCaracaAbate)),
            mortalidade: String(Formatacao.converterStringParaNumero(that.mortalidade)),
            uaMediaCiclo: String(Formatacao.converterStringParaNumero(that.uaMediaCiclo))
          },
          financeira: {
            valorGadoCabecaCIF: String(Formatacao.converterStringParaNumero(this.valorGadoCabecaCIF)),

            dataPagamentoGado: dateUtil.format(that.dataPagamentoGado, 'dd/MM/yyyy'),
            taxaRemuneracaoCapital: String(Formatacao.converterStringParaNumero(that.taxaRemuneracaoCapital)),
            diasEntreEmbarqueAbate: String(Formatacao.converterStringParaNumero(this.diasEntreEmbarqueAbate)),

            diasEntreAbateRecebimento: String(Formatacao.converterStringParaNumero(that.diasEntreAbateRecebimento)),
            diasExtrasRecebimento: String(Formatacao.converterStringParaNumero(that.diasExtrasRecebimento)),
            precoReferenciaBoiGordo: String(Formatacao.converterStringParaNumero(that.precoReferenciaBoiGordo)),
            custoVariavelExcetoNutricao: String(Formatacao.converterStringParaNumero(that.custoVariavelExcetoNutricao)),
            custoFixoTotal: String(Formatacao.converterStringParaNumero(that.custoFixoTotal)),
            despesasCabecasMes: String(Formatacao.converterStringParaNumero(this.despesasCabecasMes)),

            despesasComercializacao: String(Formatacao.converterStringParaNumero(that.despesasComercializacao)),
            deducoesAplicadasROB: String(Formatacao.converterStringParaNumero(that.deducoesAplicadasROB)),
            depreciacao: String(Formatacao.converterStringParaNumero(that.depreciacao)),
            amortizacao: String(Formatacao.converterStringParaNumero(that.amortizacao)),
            naoOperacional: String(Formatacao.converterStringParaNumero(that.naoOperacional)),
            impostoRenda: String(Formatacao.converterStringParaNumero(that.impostoRenda)),
            precoVenda: String(Formatacao.converterStringParaNumero(that.precoVenda)),
            diferencialBase: String(Formatacao.converterStringParaNumero(that.diferencialBase)),
            descontoAplicadoVendaVista: String(Formatacao.converterStringParaNumero(that.descontoAplicadoVendaVista)),
            premioEU: String(Formatacao.converterStringParaNumero(that.premioEU)),
            premioHilton: String(Formatacao.converterStringParaNumero(that.premioHilton)),
            premioAngus: String(Formatacao.converterStringParaNumero(that.premioAngus)),
            premioAcabamento: String(Formatacao.converterStringParaNumero(that.premioAcabamento)),
            outrosPremios: String(Formatacao.converterStringParaNumero(that.outrosPremios))
          }
        }
      }
      data.informacoes['ciclo'] = ciclo;
      return data
    },
    buscaResultados () {
      if (this.resultDone) {
        return true;
      }
      if (this.valorGadoCabecaCIF === '' || parseFloat(Formatacao.converterStringParaNumero(this.valorGadoCabecaCIF)) <= 0 ||
      this.dataPagamentoGado === '' || this.dataPagamentoGado === null ||
      parseFloat(Formatacao.converterStringParaNumero(this.precoVenda)) <= 0 || this.precoVenda === null) {
        if (!this.resultDone) {
          Swal('Preencha os campos', 'Por favor, preencha todos os campos marcados como obrigatórios "*" ', 'warning');
          return false
        }
      }
      let data = this.formatarDadosAntesDeCalcular();
      Swal.queue([{
        title: 'Executar simulação?',
        confirmButtonText: 'Confirmar',
        text: 'Você deseja executar sua simulação com os dados preenchidos? ',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return API.simulacao.calcular.pasto.avancado(data)
              .then(response => {
                if (response.status === 200) {
                  this.resultados = response.data.resultados
                  Armazenamento.quantidadeSimulacoes.gravar({ quantidade: response.data.total })
                  Assinatura.atualizar()
                  let card = document.getElementsByClassName('card');
                  for (let i = 0; i < card[0].getElementsByTagName('input').length; i++) {
                    card[0].getElementsByTagName('input')[i].disabled = true;
                  }
                  this.resultDone = true;
                  this.$refs.wizard.changeTab(0, 1);
                  this.$refs.wizard.changeTab(1, 2);
                  this.$refs.wizard.changeTab(2, 3);
                  return true;
                } else {
                  this.$refs.wizard.changeTab(3, 2);
                  return false;
                }
              })
              .catch(e => {
                this.$refs.wizard.changeTab(3, 2);
                return false;
              })
        }
      }]).catch(Swal.noop)
    }
  },
  created () {
    // Direcionar para assinatura
    if (this.novo && !this.compartilhado.assinatura.permitirNovaSimulacao) {
      return this.$router.push({
        name: 'meu-perfil'
      })
    }

    this.loading = true
    this.getInitialValues().then(([animais, descricoes, estados]) => {
      this.loading = false
      this.racasOpcoes = animais
      this.descricoes = descricoes.data && descricoes.data.valores
      this.estados = estados
      this.todosEstados = estados
      return this.getSimulation()
    })
  }
}
export default controller



// WEBPACK FOOTER //
// ./src/components/Dashboard/Views/Simulacoes/Pasto/CompletoCtrl.js